import {ServerError} from "@dropDesk/domain/entities/exceptions/exceptions";
import {inject, injectable} from "inversify";
import {PlanExtensionsCatalogRepository} from "@dropDesk/domain/repositories/plan_extensions/plan_extensions_catalog.repository";
import {PlanExtensionsCatalogRemoteDataSource} from "@dropDesk/data/data_source/plan_extensions/plan_extensions_catalog_remote.datasource";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";
import {PlanExtensionSimulateHireEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_simulate_hire.entity";
import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";

@injectable()
export class PlanExtensionsCatalogRepositoryImpl implements PlanExtensionsCatalogRepository {
    private _dataSource: PlanExtensionsCatalogRemoteDataSource;

    constructor(@inject(PlanExtensionsCatalogRemoteDataSource) dataSource: PlanExtensionsCatalogRemoteDataSource) {
        this._dataSource = dataSource;
    }

    public listCatalog(includeDeleted?: boolean): Promise<PlanExtensionCatalogEntity[]> {
        try {
            return this._dataSource.listCatalog(includeDeleted);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public getCatalogById(id: string): Promise<PlanExtensionCatalogEntity> {
        try {
            return this._dataSource.getCatalogById(id);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public simulateHire(idExtension: string): Promise<PlanExtensionSimulateHireEntity> {
        try {
            return this._dataSource.simulateHire(idExtension);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public hire(idExtension: string): Promise<CompanyExtensionEntity> {
        try {
            return this._dataSource.hire(idExtension);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public unsubscribe(id: string): Promise<void> {
        try {
            return this._dataSource.unsubscribe(id);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public reactivate(id: string): Promise<void> {
        try {
            return this._dataSource.reactivate(id);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public listInstalled(): Promise<CompanyExtensionEntity[]> {
        try {
            return this._dataSource.listInstalled();
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }
}
